import Immutable from 'immutable';

const Content: {
  status: string,
  title?: string | null,
  message: string,
  messageParams: Immutable.List<any>,
  info: string,
  infoParams: Immutable.List<any>,
  details: string,
  validationPath: Immutable.List<string>
} = {
  status: 'error',
  title: null,
  message: '',
  messageParams: Immutable.List(),
  info: '',
  infoParams: Immutable.List(),
  details: '',
  validationPath: Immutable.List()
};

class ErrorData extends Immutable.Record(Content) {
  static fromJS (json: object): any {
    return Immutable.fromJS(json, (key, value) => {
      switch (key) {
        case '': { // root node
          if (!Immutable.isIndexed(value)) {
            // remove null values from the map -> use the Record's defaults instead
            return new ErrorData(Immutable.Map(value).filter(Boolean));
          } else {
            return;
          }
        }
        case 'messageParams': // params
        case 'infoParams':
        case 'validationPath': {
          return value.toList();
        }
        default: { // sides elements
          return value.toOrderedMap();
        }
      }
    });
  }
}

export default ErrorData;
